module.exports = __webpack_public_path__ + "static/media/icon-studio.2a08f177.svg";